import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cashbackBanner1 from "../../assets/scratchCrad/cashbackBanner1.png";
import cashbackBanner2 from "../../assets/scratchCrad/cashbackBanner2.png";
import CheggoutLogo from "../../assets/scratchCrad/cheggoutLogo.png";
import backButton from "../../assets/backward.png";
import copyIcon from "../../assets/copyIcon.svg";
import ExpandIcon from "../../assets/backIcon.svg";
import redirectIcon from "../../assets/redirectIcon.svg";
import './scratchcard-details.scss';

const offerCode ='XTJSGLHAG54OW7';
const brandName = 'Fastrack';
const brandOffer = 'Get upto 60% off';
const brandOfferSub = 'Offer is applicable on selected products only*';
const img1 = 'https://serieverslaving.nl/wp-content/uploads/2015/11/seo-watch-free-link-preview.jpg';
const img2 = 'https://www.fastrack.in/on/demandware.static/-/Sites-titan-master-catalog/default/dw79a1943f/images/promotions/fastrack/Stunners6.0/Stunners_6_5.jpg';
const brand_logo = 'https://seeklogo.com/images/N/netflix-n-logo-0F1ED3EBEB-seeklogo.com.png';
const brand_logo2 = 'https://lh3.googleusercontent.com/sVib0342cQZ9Nyw-kiNtFC0Jj4_-aoYHttgdGxg8sTYz3gpVjc558RJY7gPUarAyy-zQ4rKTBXAFL8R8cZh6YzR6_2NrMCImUZMFoDyP=w256-rw';
const offerDetails ='Expires on December 28 2024, This voucher can be redeemed in Tata Nue app, The discount will be applied at the time of purcahse, Coupon Free trial will be apply within 24 hours';
const ScratchCardDetails = () => {
    const type = 'coupon'; //cashback or coupon
    const navigate = useNavigate();
    const [msg, setMsg] = useState(false);
    const [detailsExpanded, setDetailsExpanded] = useState(true);
    const [stepsExpanded, setStepsExpanded] = useState(true);
    const [tcExpand, setTcExpand] = useState(true);
    const offerDetailsArray = offerDetails.split(',');

    const copyToClipboard = (code) => {
        navigator.clipboard.writeText(code).then(() => {
            setMsg(true);
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }

    const handleDetailsExpand = () => {
        setDetailsExpanded(!detailsExpanded);
    }

    const handleStepsExpand = () => {
        setStepsExpanded(!stepsExpanded);
    }

    const handleTcExpand = () => {
        setTcExpand(!tcExpand);
    }

    const handleBack = () => {
        navigate('/order-history');
    }

    return(
        <div className="scratchcard-details-main">
        {type==='cashback'&&
            <div className="cashback-main-conatiner">
                <div className="cashback-img-overlay-container">
                    <img onClick={handleBack} src={backButton} alt="back_btn" className="cashback-back-btn" />
                    <img className="cashback-main-img" src={cashbackBanner1} alt="cashback_image" />
                    <div className="cashback-img-overlay"></div>
                </div>
                <div className="cashback-logo-name-section">
                    <img className="cashback-logo-container" src={CheggoutLogo} alt="brand_logo" />
                    <div className="cashback-name-text">{"Cheggout"}</div>
                </div>
                <div className="cashback-offer-section">
                    <div className="cashback-offer-main-title">&#8377;10 - &#8377;50</div>
                    <div className="cashback-offer-sub-title">{"Cashback on Shopping"}</div>
                </div>
                <div className="cashback-days-status-container">
                    <div className="cashback-days-left">{"3d left"}</div>
                    <div className="cashback-status">{"Activating"}</div>
                </div>
                <div className="cashback-details-section">
                    <div className="cashback-deatils-header">
                        <div className="cashback-deatils-title">Details</div>
                    </div>
                    <div className='cashback-details-body'> 
                        <ul>
                            {offerDetailsArray.map((detail, index) => (
                                <li className="cashback-deatils-points" key={index}>{detail.trim()}</li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="cashback-redeem-btn-section">
                    <div className="cashback-redeem-btn">
                        <img className="cashback-redeem-img" src={redirectIcon} alt="redirect_icon" />
                            Redeem Now
                    </div>
                </div>
            </div>
        }
        {type==='coupon'&&
            <>
                <div className="brand-img-overlay-container">
                    <img onClick={handleBack} src={backButton} alt="back_btn" className="back-btn" />
                    <img className="brand-main-img" src={img2} alt="brand_image" />
                    <div className="brand-img-overlay"></div>
                </div>
                <div className="brand-logo-name-section">
                    <img className="brand-logo-container" src={brand_logo2} alt="brand_logo" />
                    <div className="brand-name-text">{brandName}</div>
                </div>
                <div className="brand-offer-section">
                    <div className="brand-offer-main-title">{brandOffer}</div>
                    <div className="brand-offer-sub-title">{brandOfferSub}</div>
                    <div className="brand-offer-code">
                        {offerCode} 
                        <div className="brand-offer-code-copy" onClick={() => copyToClipboard(offerCode)}>
                        <img src={copyIcon} alt="copy_text"/>
                        </div>
                    </div>
                    {msg&&<div style={{fontSize: "14px", color: 'green'}}>Code Copied to clipboard!!</div>}
                </div>
                <div className="offer-details-section">
                    <div className="offer-deatils-header">
                        <div className="offer-deatils-title">Details</div>
                        <div className="offer-deatils-expand-icon" onClick={handleDetailsExpand}>
                            <img className={detailsExpanded?"offer-details-expanded":"offer-details-not-expanded"} src={ExpandIcon} alt="Expand_Icon" />
                        </div>
                    </div>
                    <div className={`offer-details-body ${detailsExpanded ? 'expanded' : ''}`}> 
                        <ul>
                            {offerDetailsArray.map((detail, index) => (
                                <li className="offer-deatils-points" key={index}>{detail.trim()}</li> 
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="offer-redeem-steps-section">
                    <div className="offer-redeem-steps-header">
                        <div className="offer-redeem-steps-title">How to redeem</div>
                        <div className="offer-redeem-steps-expand-icon" onClick={handleStepsExpand}>
                            <img className={stepsExpanded?"offer-redeem-steps-expanded":"offer-redeem-steps-not-expanded"} src={ExpandIcon} alt="Expand_Icon" />
                        </div>
                    </div>
                    <div className={`offer-redeem-steps-body ${stepsExpanded ? 'expanded' : ''}`}>
                            <ol>
                                <li className="redeem-step-points">Click on Redeem Now</li>
                                <li className="redeem-step-points">Add product(s) to the cart</li>
                                <li className="redeem-step-points">Click on the cart page</li>
                                <li className="redeem-step-points">Add the voucher code to apply the offer</li>
                                <li className="redeem-step-points">Continue and place the order</li>
                            </ol>
                    </div>
                </div>
                <div className="offer-tc-section">
                    <div className="offer-tc-header">
                        <div className="offer-tc-title">Terms & Conditions</div>
                        <div className="offer-tc-expand-icon" onClick={handleTcExpand}>
                            <img className={tcExpand?"offer-tc-expanded":"offer-tc-not-expanded"} src={ExpandIcon} alt="Expand_Icon" />
                        </div>
                    </div>
                    <div className={`offer-tc-body ${tcExpand? 'expanded':''}`}>
                            <ul>
                                <li className="offer-tc-points">We have no role to play on taxes and charges levied by government and restaurants.</li>
                                <li className="offer-tc-points">Other T&C may apply</li>
                            </ul>
                    </div>
                </div>
                <div className="offer-redeem-btn-section">
                    <div className="offer-redeem-btn">
                        <img className="offer-redeem-img" src={redirectIcon} alt="redirect_icon" />
                            Redeem Now
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default ScratchCardDetails;